






































































  import { Component, Vue, Prop } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import { Stocks } from '@one/types'
  import { GTMListType } from '~/plugins/gtm/gtm'
  import OneSwiperProduct from '~/components/molecules/swipers/OneSwiperProduct.vue'

  const products = namespace('products')
  const stocks = namespace('stocks')
  const layout = namespace('layout')

  @Component({
    components: {
      OneRelatedProductsList: () => import('~/components/molecules/lists/OneRelatedProductsList.vue'),
      OneProductOverview: () => import('./OneProductOverview.vue'),
      OneProductOverviewList: () => import('./OneProductOverviewList.vue'),
      OneSwiperProducts: OneSwiperProduct,
    },
  })
  export default class OneRelatedProducts extends Vue {
    name: string = 'one-related-products'
    loading: boolean = false

    @stocks.Action fetchStocksForProductsAndWarehouses: any
    @stocks.Getter getProductOrderQuantityInWarehouse: any
    @stocks.Getter getProductStocks: any
    @stocks.Getter getProductWarehouse: any
    @stocks.Getter getWarehouses: any
    @stocks.Getter getDefaultWarehouseId: any
    @products.Action fetchProductsById: any
    @products.Action fetchPricesForProducts: any
    @products.Getter getProduct: any
    @products.Getter getProductOrderUnit: any
    @products.Getter getProductPrice: any
    @products.Getter getProductImage: any
    @layout.Getter getCurrency: any
    @layout.Getter isGrossSelected: any

    @Prop({
      required: true,
    })
    data!: Array<any>

    @Prop({
      type: String,
      default() {
        // @ts-ignore
        return this.$t('product_page.related_products') as string
      },
    })
    title!: string

    @Prop({
      type: Boolean,
      default: false,
    })
    isList!: boolean

    filteredProductsIds: Array<string> = []
    map: any = new Map()

    get productsIds(): Array<string> {
      return this.data.filter(x => x).map(x => x.id)
    }

    GTMListType: any = GTMListType

    getProductQuantity(productId: string): number | boolean | null {
      const stocks = this.getProductStocks(productId)
      if (stocks?.stockVisibilityMode === Stocks.StockVisibilityMode.HIDDEN) {
        return this.getProductWarehouse(productId, this.getDefaultWarehouseId)?.available ?? stocks.available ?? false
      }
      return this.getProductOrderQuantityInWarehouse(productId, this.getDefaultWarehouseId)
    }

    async created() {
      this.loading = true
      const productIds = this.data
        .map(x => x.id)
        .filter(x => x)
      try {
        const allProducts = await this.fetchProductsById(productIds)
        this.filteredProductsIds = allProducts.map(x => x.id)
      } catch (e) {
        this.$logger.warn('fetching products warn ', e)
      }
      if (this.$utils.isPurchaseEnabledOrAuthenticated) {
        try {
          if (this.$utils.hasPricesEnabled) {
            await this.fetchPricesForProducts(this.filteredProductsIds)
          }
          await this.fetchStocksForProductsAndWarehouses({
            skus: this.filteredProductsIds,
            warehouses: this.getWarehouses,
          })
        } catch (e) {
          this.$logger.warn('fetching price, stocks or warehouses warn ', e)
        } finally {
          this.loading = false
        }
      }
    }
  }
